// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentId_MIAB } from "../schema";

export function serialize_ContentId_MIAB_internal(value: ContentId_MIAB): unknown {
  return ((value: { contentType: "MIAB"; id: bigint }): unknown => {
    return {
      contentType: ((value: "MIAB"): unknown => {
        return value;
      })(value["contentType"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
    };
  })(value);
}
export function serialize_ContentId_MIAB(obj: ContentId_MIAB): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentId_MIAB_internal(obj));
}
export function deserialize_ContentId_MIAB_internal(value: unknown): ParserResult<ContentId_MIAB> {
  return ((
    value: unknown,
  ): ParserResult<{
    contentType: "MIAB";
    id: bigint;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/MiabId]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/MiabId]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "contentType")) {
      return { success: false, reason: `[#/components/schemas/MiabId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
    }
    const parsed_contentType = ((): ParserResult<"MIAB"> => {
      return ((value: unknown): ParserResult<"MIAB"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/MiabId/contentType]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "MIAB":
            return { success: true, value: "MIAB" };
          default:
            return { success: false, reason: `[#/components/schemas/MiabId/contentType]: '${value}' expected to be enum, one of 'MIAB'.` };
        }
      })(value["contentType"]);
    })();
    if (!parsed_contentType.success) {
      return { success: false, reason: parsed_contentType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/MiabId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/MiabId/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
  })(value);
}
export function deserialize_ContentId_MIAB(str: string): ParserResult<ContentId_MIAB> {
  return deserialize_ContentId_MIAB_internal(parseJsonWithNumbersAsBigint(str));
}
